import { Component, OnInit, Input, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { SectionModel } from '../../models/section.model';
import { ApplicationConstant } from 'src/app/application.constant';
import { LookUpResourceModel } from '../../models/lookup-resource.model';
import { ContractType } from '../../../shared/models/contract/contract-type.model';
import { CounterService } from '../../../shared/service/data/counter.service';
import { counter } from '../../../shared/constant/counter.constatnt';
import { SwProcessStateService } from '../../service/ui/sw-process-state.service';

@Component({
  selector: 'single-section',
  templateUrl: './single-section.component.html'
})
export class SingleSectionSwComponent implements OnInit, AfterContentChecked {
  public isActive = false;
  public questionDetailsModel: Array<LookUpResourceModel>;

  @Input() sectionDetails: SectionModel;
  @Input() contractType: ContractType;

  constructor(
    private counterService: CounterService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    public swProcessStateService: SwProcessStateService,
  ) {}

  public ngOnInit() {
    this.questionDetailsModel = ApplicationConstant.lookupResourceDetails.filter((f) => f.SectionName === this.sectionDetails.SectionName && f.IsVisible);
  }

  public ngAfterContentChecked() {
    this.changeDetectorRef.detectChanges();
  }

  public toggleActive(): void {
    this.isActive = !this.isActive;
    this.saveCounter();
  }

  private saveCounter(): void {
    let counterName = '';

    if (this.sectionDetails.SectionName === 'InsurancePolicySection') {
      counterName = this.isActive ? counter.InsuredPage : counter.InsuredPageFold;
    } else if (this.sectionDetails.SectionName === 'InsuredPeopleDetails') {
      counterName = this.isActive ? counter.PolicyHolderPage : counter.PolicyHolderPageFold;
    } else if (this.sectionDetails.SectionName === 'OtherSection') {
      counterName = this.isActive ? counter.ContactPage : counter.ContactPageFold;
    }

    if (counterName) {
      this.counterService.processCounterByCounterName(counterName).subscribe();
    }
  }

  public isValidSection(sectionDetail: SectionModel): boolean {
    if (!this.swProcessStateService.isHealthContractLoaded()) {
      return true;
    }

    const hasInvalidQuestions = this.questionDetailsModel.some((question) => question.SectionName === sectionDetail.SectionName && !question.IsValid);

    sectionDetail.IsError = hasInvalidQuestions;
    return !hasInvalidQuestions;
  }
}
